import type { FC } from 'react'

import dynamic from 'next/dynamic'

import theme from '@segment/matcha/foundations/Theme'

import { MongoDbMonoLogo, DailyHarvestMonoLogo } from '@segment/matcha/components/CompanyLogos/CompanyMono'

import { carouselLogos } from '@segment/templates/LogoCarousel/data'

import capitalizeFirstLetter from '@segment/utils/capitalizeFirstLetter'

import type { Audience } from '..'

interface TemplateProps {
  audience: Audience
}
const AudienceTestimonialLogo: FC<TemplateProps> = ({ audience }) => {
  const renderByAudience = () => {
    switch (audience) {
      case `marketing`:
        return <MongoDbMonoLogo color={theme.palette.neutrals.white[100]} />
      case `product`:
        return <DailyHarvestMonoLogo color={theme.palette.neutrals.white[100]} />
      case `engineering`:
        return <DailyHarvestMonoLogo color={theme.palette.neutrals.white[100]} />
      default:
        return <MongoDbMonoLogo color={theme.palette.neutrals.white[100]} />
    }
  }

  return renderByAudience()
}

const audienceCarouselLogos = (audience: Audience) => {
  const defaultData = [
    carouselLogos.DIGITAL_OCEAN,
    carouselLogos.IBM,
    carouselLogos.DOMINOS,
    carouselLogos.ANHEUSER_BUSCH,
    carouselLogos.VMWARE,
    carouselLogos.LEVIS,
    carouselLogos.LOG_ME_IN,
    carouselLogos.CLEAR_SCORE,
    carouselLogos.VACASA,
    carouselLogos.STAPLES,
    carouselLogos.INTUIT,
    carouselLogos.THE_SKIMM,
    carouselLogos.DRIFT,
    carouselLogos.ALLERGAN,
    carouselLogos.GLOSSIER,
    carouselLogos.AB_IN_BEV,
  ]
  switch (audience) {
    case `marketing`:
      return defaultData
    case `product`:
      return [carouselLogos.DIGITAL_OCEAN, carouselLogos.ALLERGAN, carouselLogos.GLOSSIER, carouselLogos.AB_IN_BEV]
    case `engineering`:
      return [carouselLogos.DIGITAL_OCEAN, carouselLogos.ALLERGAN, carouselLogos.GLOSSIER, carouselLogos.AB_IN_BEV]
    default:
      return defaultData
  }
}

const AudienceImage: FC<TemplateProps> = ({ audience }) => {
  const Images = dynamic(() => import(`./${capitalizeFirstLetter(audience)}Images`))
  return <Images />
}

export { AudienceTestimonialLogo, AudienceImage, audienceCarouselLogos }
